import { STATUSPAGE } from '@repo/ui';
import {
  GetAllUsersMetricsResponse,
  GetActivitiesInProgressCountResponse,
  GetCompletedAndMissedActivitiesCountResponse,
} from 'domain/models';
import { useLegends } from 'presentation/app/hooks/useLegends';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, Col, Row } from 'reactstrap';

interface IProps {
  users: GetAllUsersMetricsResponse;
  completedAndMissedActivitiesCount: GetCompletedAndMissedActivitiesCountResponse;
  activitiesInProgressCount: GetActivitiesInProgressCountResponse;
  statusCompletedAndMissedActivitiesCount: STATUSPAGE;
  statusActivitiesInProgressCount: STATUSPAGE;
}

export const WidgetsActivities = ({
  users,
  completedAndMissedActivitiesCount,
  activitiesInProgressCount,
  statusCompletedAndMissedActivitiesCount,
  statusActivitiesInProgressCount,
}: IProps) => {
  const { getLegends } = useLegends();

  return (
    <React.Fragment>
      <div className="d-flex flex-column">
        <Row>
          <Col xl={3} md={6}>
            <Card className="card-animate overflow-hidden">
              <div
                className="position-absolute start-0"
                style={{ zIndex: '0' }}
              >
                <svg
                  version="1.2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 120"
                  width="200"
                  height="120"
                >
                  <path
                    id="Shape 8"
                    style={{ opacity: '.05', fill: 'rgb(128 128 128)' }}
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                  />
                </svg>
              </div>
              <CardBody style={{ zIndex: '1' }}>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <h1>
                      <i className="ri-group-line"></i>
                    </h1>
                  </div>
                  <div className="flex-shrink-0">
                    <h4 className="fs-22 fw-semibold ff-secondary mb-3 text-end">
                      <span className="counter-value">
                        {statusCompletedAndMissedActivitiesCount ===
                        STATUSPAGE.LOADING ? (
                          <Skeleton
                            baseColor="#e8e8e8c5"
                            highlightColor="#bababa96"
                            width={80}
                          />
                        ) : (
                          String(users?.qtde ?? 0)
                        )}
                      </span>
                    </h4>
                    <span className="fw-medium text-muted text-truncate">
                      {`${getLegends('ESTUDANTE', true)} online`}
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} md={6}>
            <Card className="card-animate overflow-hidden">
              <div
                className="position-absolute start-0"
                style={{ zIndex: '0' }}
              >
                <svg
                  version="1.2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 120"
                  width="200"
                  height="120"
                >
                  <path
                    id="Shape 8"
                    style={{ opacity: '.05', fill: 'rgb(128 128 128)' }}
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                  />
                </svg>
              </div>
              <CardBody style={{ zIndex: '1' }}>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <h1>
                      <i className="ri-time-line"></i>
                    </h1>
                  </div>
                  <div className="flex-shrink-0">
                    <h4 className="fs-22 fw-semibold ff-secondary mb-3 text-end">
                      <span className="counter-value">
                        {statusActivitiesInProgressCount ===
                        STATUSPAGE.LOADING ? (
                          <Skeleton
                            baseColor="#e8e8e8c5"
                            highlightColor="#bababa96"
                            width={80}
                          />
                        ) : (
                          String(activitiesInProgressCount?.count ?? 0)
                        )}
                      </span>
                    </h4>
                    <span className="fw-medium text-muted text-truncate">
                      Atividades em andamento
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} md={6}>
            <Card className="card-animate overflow-hidden">
              <div
                className="position-absolute start-0"
                style={{ zIndex: '0' }}
              >
                <svg
                  version="1.2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 120"
                  width="200"
                  height="120"
                >
                  <path
                    id="Shape 8"
                    style={{ opacity: '.05', fill: 'rgb(128 128 128)' }}
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                  />
                </svg>
              </div>
              <CardBody style={{ zIndex: '1' }}>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <h1>
                      <i className="ri-checkbox-multiple-line"></i>
                    </h1>
                  </div>
                  <div className="flex-shrink-0">
                    <h4 className="fs-22 fw-semibold ff-secondary mb-3 text-end">
                      <span className="counter-value">
                        {statusCompletedAndMissedActivitiesCount ===
                        STATUSPAGE.LOADING ? (
                          <Skeleton
                            baseColor="#e8e8e8c5"
                            highlightColor="#bababa96"
                            width={80}
                          />
                        ) : (
                          (
                            completedAndMissedActivitiesCount?.completed ?? 0
                          ).toLocaleString('pt-BR')
                        )}
                      </span>
                    </h4>
                    <span className="fw-medium text-muted text-truncate">
                      Atividades finalizadas
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} md={6}>
            <Card className="card-animate overflow-hidden">
              <div
                className="position-absolute start-0"
                style={{ zIndex: '0' }}
              >
                <svg
                  version="1.2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 120"
                  width="200"
                  height="120"
                >
                  <path
                    id="Shape 8"
                    style={{ opacity: '.05', fill: 'rgb(128 128 128)' }}
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                  />
                </svg>
              </div>
              <CardBody style={{ zIndex: '1' }}>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <h1>
                      <i className="ri-error-warning-line"></i>
                    </h1>
                  </div>
                  <div className="flex-shrink-0">
                    <h4 className="fs-22 fw-semibold ff-secondary mb-3 text-end">
                      <span className="counter-value">
                        {statusCompletedAndMissedActivitiesCount ===
                        STATUSPAGE.LOADING ? (
                          <Skeleton
                            baseColor="#e8e8e8c5"
                            highlightColor="#bababa96"
                            width={80}
                          />
                        ) : (
                          (
                            completedAndMissedActivitiesCount?.missed ?? 0
                          ).toLocaleString('pt-BR')
                        )}
                      </span>
                    </h4>
                    <span className="fw-medium text-muted text-truncate">
                      Atividades perdidas justificadas
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};
